import React from 'react';
import { Tree, TreeNode } from 'react-organizational-chart';
import JDReportCard from './JDReportCard';

const RankingResultsTree = ({ timeStamp, API_URL, author_email, run_id }) => {
  return (
    <Tree
      lineWidth="5px"
      lineColor="gray"
      lineStyle="solid"
      lineHeight="40px"
      lineBorderRadius="10px"
      label={timeStamp.pool_name}
    >
      {timeStamp.jds.map((jp, index) => (
        <TreeNode
          key={index}
          label={
            <JDReportCard
              API_URL={API_URL}
              author_email={author_email}
              run_id={run_id}
              jd={jp}
            />
          }
        />
      ))}
    </Tree>
  );
};

export default RankingResultsTree;
